export default __webpack_public_path__ + "static/intro-b3d5229ff3f24972f266e724524e1ec7.mp4";